// extracted by mini-css-extract-plugin
module.exports = {"pagination":"WebshopList_pagination__5LQup","spinnerHolder":"WebshopList_spinnerHolder___PZUI","spinner":"WebshopList_spinner__D7Lbq"};